<ml-mdm-command-spinner [commandProgress]="commandProgress$"
                        [small]="true"
                        [reverse]="true"
                        [direction]="'right'">
  <button [ngClass]="class()"
          (click)="playLostModeSound()"
          [disabled]="(isEnabled | async) === false"
          [attr.title]="
      isSupervised()
        ? hasSupportedOS()
          ? ''
          : 'Only available in iOS 9.3 and later.'
        : 'Only available when device is supervised.'
    ">
    <ng-content></ng-content>
  </button>
</ml-mdm-command-spinner>